// extracted by mini-css-extract-plugin
module.exports = {"container":"container--15VA5"};